var map = {
	"./dr_anthony.png": 1378,
	"./dr_arif.png": 8376,
	"./dr_hermin.png": 9177,
	"./dr_julius.png": 4092,
	"./dr_susan.png": 1392,
	"./dr_tita.png": 7565,
	"./dranthony.png": 3552,
	"./drarief.jpg": 3111,
	"./drhermin.png": 2258,
	"./drjulius.png": 3366,
	"./drrima.png": 1618,
	"./drsusan.png": 1023,
	"./drtita.png": 5091,
	"./haimage.jpg": 8896,
	"./hwimage.png": 4709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;